import { useLocation } from 'react-router-dom'
import { AppLayout, AppContent } from '../../../styles/AppStyles'
import { SkeletonAppHeader } from './SkeletonAppHeader'
import { SkeletonDashboard } from './SkeletonDashboard'
import { SkeletonMindmap } from './SkeletonMindmap'
import { SkeletonReport } from './SkeletonReport'
import { SkeletonSettings } from './SkeletonSettings'
import { SkeletonSurveyInsights } from './SkeletonSurveyInsights'
import { SkeletonSurveyOnboarding } from './SkeletonSurveyOnboarding'
import { SkeletonUpgrade } from './SkeletonUpgrade'
import { SkeletonUpgradeSuccess } from './SkeletonUpgradeSuccess'

export function RouteAwareSkeleton() {
  const { pathname } = useLocation()

  // Standalone routes — no AppLayout wrapper
  if (pathname === '/survey') return <SkeletonSurveyOnboarding />
  if (pathname === '/upgrade/success') return <SkeletonUpgradeSuccess />
  if (/^\/upgrade/.test(pathname)) return <SkeletonUpgrade />

  // App-layout routes
  let content: React.ReactNode

  if (/\/mindmap\/[^/]+\/report/.test(pathname)) {
    content = <SkeletonReport />
  } else if (/\/survey\/[^/]+\/insights/.test(pathname)) {
    content = <SkeletonSurveyInsights />
  } else if (/\/mindmap\/[^/]+/.test(pathname)) {
    content = <SkeletonMindmap />
  } else if (pathname === '/settings') {
    content = <SkeletonSettings />
  } else {
    content = <SkeletonDashboard />
  }

  return (
    <AppLayout>
      <SkeletonAppHeader />
      <AppContent>{content}</AppContent>
    </AppLayout>
  )
}
